"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var InvoiceSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M12.7,6 L11.3,6 L10.3,5 L5.99015073,5 L5.99015073,14 L9,14 L9,15 L5.99015073,15 C5.43846979,15 4.99124403,14.5522847 4.99124403,14 L4.99124403,5 C4.99124403,4.44771525 5.43846979,4 5.99015073,4 L10.7,4 L12.7,6 Z M10,13 L11,13 C11,13.5522847 11.4477153,14 12,14 L13,14 C13.5522847,14 14,13.5522847 14,13 C14,12.4477153 13.5522847,12 13,12 L12,12 C10.8954305,12 10,11.1045695 10,10 C10,8.8954305 10.8954305,8 12,8 L12,7 L13,7 L13,8 C14.1045695,8 15,8.8954305 15,10 L14,10 C14,9.44771525 13.5522847,9 13,9 L12,9 C11.4477153,9 11,9.44771525 11,10 C11,10.5522847 11.4477153,11 12,11 L13,11 C14.1045695,11 15,11.8954305 15,13 C15,14.1045695 14.1045695,15 13,15 L13,16 L12,16 L12,15 C10.8954305,15 10,14.1045695 10,13 Z" })));
};
InvoiceSmall.displayName = 'InvoiceSmall';
exports.default = InvoiceSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=InvoiceSmall.js.map